import React from 'react'
import cn from 'classnames'
import {
  StyledVariable,
  UrgencyHandler,
  LINK_KEY,
  OFFER_TERMS_TEAL_VARIABLE_NAME,
  TEXT_KEY,
  type UrgencyEntries,
} from '@mc/feature-variables'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../../i18n'

const URGENCY_CONFIG = {
  link: {
    variableName: OFFER_TERMS_TEAL_VARIABLE_NAME,
    variableKey: LINK_KEY,
  },
  text: {
    variableName: OFFER_TERMS_TEAL_VARIABLE_NAME,
    variableKey: TEXT_KEY,
  },
} as UrgencyEntries

export const BogoTermsLinkComponent = ({
  textFixed,
  className = 'mc-text--link',
  newTab = true,
  onClick,
}: {
  textFixed?: string
  className?: string
  newTab?: boolean
  onClick?: (linkText: string) => void
}) => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  return (
    <UrgencyHandler config={URGENCY_CONFIG} trackEV={true}>
      {({ link, text }) => (
        <a
          className={cn('mc-text--link', className)}
          href={link as string}
          target={newTab ? '_blank' : '_self'}
          rel='noreferrer'
          onClick={() =>
            onClick?.((textFixed || text || t('offerTerms.label')) as string)
          }
        >
          <StyledVariable
            text={textFixed || text}
            defaultCopy={t('offerTerms.label')}
          />
        </a>
      )}
    </UrgencyHandler>
  )
}

export const BogoTermsLink = withI18nContext(i18nInstance)(
  BogoTermsLinkComponent,
)
